/**
 * Single source of truth for PAM frontend URL shapes. Every PAM page is keyed
 * on a single ULID (issue #1483); the submission page carries its tab in a
 * query string. All call sites import from here so the next URL change is a
 * one-file edit. Tenant prefixing stays at call sites via `toTenantPath`.
 */

export const pamHomePath = (): string => '/modules/pam';

export type PamModuleTab =
  | 'dashboard'
  | 'visualisations'
  | 'questions'
  | 'members'
  | 'costed-actions'
  | 'contacts'
  | 'files';

export function pamSubmissionPath(submissionId: string, opts?: { tab?: PamModuleTab; search?: string }): string {
  const base = `/modules/pam/${submissionId}`;
  // Build via URLSearchParams so an incoming `search` (e.g. `location.search`)
  // merges cleanly with `tab` without duplicate keys.
  const params = new URLSearchParams((opts?.search ?? '').replace(/^\?/, ''));
  if (opts?.tab !== undefined) params.set('tab', opts.tab);
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

export const pamSaqPath = (submissionSaqId: string): string => `/modules/pam/saq/${submissionSaqId}`;

export const pamQuestionPath = (submissionQuestionId: string): string => `/modules/pam/q/${submissionQuestionId}`;
